import { render, staticRenderFns } from "./publication.vue?vue&type=template&id=cefb54fe&scoped=true&"
import script from "./publication.vue?vue&type=script&lang=js&"
export * from "./publication.vue?vue&type=script&lang=js&"
import style0 from "./publication.vue?vue&type=style&index=0&id=cefb54fe&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cefb54fe",
  null
  
)

export default component.exports